var _circle, _g, _circle2, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeAtendimentoDomiciliar = function SvgIconeAtendimentoDomiciliar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_31394)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#9DE695"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14652_31394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 12,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14652_31394)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1988 5.7011C20.9588 5.5001 20.6912 5.3999 20.396 5.3999C20.1014 5.3999 19.8332 5.5001 19.5932 5.7011L14.582 9.7445C14.4086 9.9545 14.3594 10.1819 14.4344 10.4261C14.5094 10.6709 14.6912 10.7933 14.981 10.7933L15.5978 10.7999L15.6002 15.6083C15.6002 16.4081 16.0004 16.8059 16.8002 16.7999H18.0002L22.8002 16.8083H24.0002C24.8 16.8083 25.2002 16.4081 25.2002 15.6083L25.2002 10.7999L25.7906 10.7933C26.0678 10.7921 26.2532 10.6703 26.3468 10.4261C26.4404 10.1825 26.3888 9.9563 26.192 9.7469L21.1988 5.7011Z",
    fill: "#E1F6DF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14652_31394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1988 5.7011C20.9588 5.5001 20.6912 5.3999 20.396 5.3999C20.1014 5.3999 19.8332 5.5001 19.5932 5.7011L14.582 9.7445C14.4086 9.9545 14.3594 10.1819 14.4344 10.4261C14.5094 10.6709 14.6912 10.7933 14.981 10.7933L15.5978 10.7999L16.8002 9.5999L20.4002 6.8513L23.999 9.5999L25.2002 10.7999L25.7906 10.7933C26.0678 10.7921 26.2532 10.6703 26.3468 10.4261C26.4404 10.1825 26.3888 9.9563 26.192 9.7469L21.1988 5.7011Z",
    fill: "#0E4700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.6 11.3999H22.2V16.7999H18.6V11.3999Z",
    fill: "#217B00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1661 18.6916C12.1661 18.6916 9.95686 18.5603 9.1034 19.4422C6.62035 22.0079 3.62664 27.7329 1.75182 31.0762C1.19284 32.0731 0.574088 32.6012 0.29756 33.0929C-0.124623 33.8435 -0.124644 34.9224 0.531976 35.1101C0.766674 35.1771 1.23579 34.5471 1.32958 34.3125C1.47035 34.594 1.65799 34.8755 1.89255 34.7348C2.03332 34.6503 1.75182 34.594 2.40858 33.3743C3.61662 31.1308 9.86751 23.9926 9.86751 23.9926L10.618 28.6369L16.5758 28.6368L17.2326 23.6636C20.9855 23.8043 24.8644 22.4832 26.5211 19.0663C27.2717 17.5182 27.7408 17.2836 27.8815 16.7676C28.1938 15.6227 27.7877 14.834 27.3655 14.7973C27.0384 14.7689 26.8495 15.501 26.7088 15.7356C26.568 15.6417 26.3804 15.1726 26.052 15.4072C25.8573 15.5462 26.3804 15.501 25.489 17.7528C24.5606 20.0983 20.9043 22.1839 16.9981 19.4422C16.1365 18.8375 14.887 18.6916 14.887 18.6916L12.1661 18.6916Z",
    fill: "#54C241"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7548 29.3372C16.7548 29.3372 13.8078 29.6268 10.77 29.3372C9.5448 25.5335 10.6625 20.2058 12.4022 19.1064C12.4022 19.1064 13.1266 19.7446 13.8531 19.7337C14.5562 19.7232 15.1679 19.2511 15.1679 19.2511C17.418 20.8332 17.4634 26.8172 16.7548 29.3372Z",
    fill: "#9DE695"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_14652_31394)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0379 19.4105C20.2829 20.2491 22.5287 21.088 25.3769 17.454L26.925 18.4861C25.8311 22.928 21.951 23.9455 19.6683 24.5441C18.7205 24.7927 18.0481 24.969 17.9649 25.2883C17.688 26.3497 20.9846 41.155 20.9846 41.155H15.7305L14.6046 19.7633L15.0738 18.6844C16.0942 18.6844 17.066 19.0474 18.0379 19.4105ZM6.19048 40.9204H12.9631C13.0765 38.5494 13.4791 19.7164 13.4791 19.7164L12.2594 18.6844C12.2594 18.6844 10.0473 18.5231 8.88183 19.4819C5.9733 21.8744 2.6252 27.3523 0.795654 31.9027L2.95358 32.9817C3.93814 31.9375 5.92465 29.1587 7.24044 27.3181C7.99355 26.2647 8.52692 25.5185 8.52692 25.581C8.52692 28.985 7.36224 34.9309 6.50578 39.3033C6.39439 39.872 6.2882 40.414 6.19048 40.9204Z",
    fill: "#E1F6DF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7279 16.0848C16.6256 16.7691 16.338 17.277 15.8821 17.6417C15.5068 17.9419 15.0305 17.9044 14.9227 18.1296C14.815 18.3547 15.0872 18.6737 15.0872 18.6737C15.0872 18.6737 14.5404 19.3774 13.7429 19.3774C12.9454 19.3774 12.1948 18.6737 12.1948 18.6737C12.5404 18.017 12.5404 16.6483 12.5404 16.6483C12.4339 16.5179 12.3512 16.4147 12.3512 16.4147C12.3512 16.4147 12.0616 16.0432 11.9575 15.6706C11.8533 15.298 11.9245 14.8467 11.9767 14.6102C12.0393 14.3265 12.1694 14.0416 12.3512 13.8075C12.5355 13.5702 12.7649 13.3488 13.2226 13.1523C14.1322 12.7618 14.8446 13.0383 15.0872 13.1523C15.3298 13.2663 15.5645 13.4348 15.7896 13.685C16.0148 13.9352 16.8765 15.0896 16.7279 16.0848Z",
    fill: "#54C241"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2002 13.8094C14.9744 13.8872 15.3173 14.487 15.0829 14.8858C14.8484 15.2846 14.0866 15.9566 14.0866 15.9566C14.0866 15.9566 13.8061 17.5032 13.4581 17.943C12.7915 18.7855 12.0859 18.5149 11.579 18.7856C11.1853 18.9958 10.171 19.882 9.44486 20.0214C8.71868 20.1608 7.67546 19.882 7.32003 19.1403C6.9646 18.3986 6.9821 17.7005 7.61195 16.9921C8.2418 16.2837 9.0303 16.7761 9.36625 16.5312C9.7022 16.2862 9.63629 15.597 10.2009 15.0939C10.7995 14.5606 11.579 14.4143 11.579 14.4143C11.579 14.4143 11.8583 13.47 12.6851 12.9996C13.5119 12.5291 14.3944 12.5918 15.0143 12.8174C15.8865 13.1349 16.0706 13.9843 15.9782 13.994C15.8859 14.0037 15.426 13.7317 15.2002 13.8094Z",
    fill: "#0E4700"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8359 19.1063V21.3365C11.8359 22.4012 12.6237 23.3149 13.6848 23.4624C13.7064 24.2861 13.3633 27.0199 15.9726 27.0199C16.2796 27.0199 16.5836 26.9594 16.8673 26.8419C17.151 26.7244 17.4087 26.5522 17.6258 26.3351C17.8429 26.1179 18.0152 25.8602 18.1327 25.5765C18.2502 25.2928 18.3106 24.9888 18.3106 24.6818V24.2178C18.7279 24.0667 19.0301 23.671 19.0301 23.207C19.0301 22.9208 18.9164 22.6463 18.714 22.4439C18.5116 22.2415 18.2371 22.1279 17.9509 22.1279C17.6647 22.1279 17.3903 22.2415 17.1879 22.4439C16.9855 22.6463 16.8718 22.9208 16.8718 23.207C16.8718 23.671 17.174 24.0703 17.5912 24.2178V24.6494C17.5912 25.5487 16.8718 26.2681 15.9726 26.2681C14.2194 26.2681 14.433 24.13 14.433 23.4588C15.433 23.2429 16.1524 22.3437 16.1524 21.3365V18.6747C16.1524 18.1952 15.9125 17.9553 15.433 17.9553C14.5697 17.9553 14.8334 18.6747 15.0733 18.6747H15.433V21.3365C15.433 21.7181 15.2814 22.0841 15.0116 22.3539C14.7417 22.6237 14.3758 22.7753 13.9942 22.7753C13.6126 22.7753 13.2466 22.6237 12.9768 22.3539C12.7069 22.0841 12.5553 21.7181 12.5553 21.3365V18.8186L12.4115 18.6747L11.8359 19.1063Z",
    fill: "#217B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31394",
    x: 0.222222,
    y: 0.111111,
    width: 35.5556,
    height: 35.5556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.888889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.888889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.556863 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31394",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31394",
    x: 13.6941,
    y: 4.69357,
    width: 13.4042,
    height: 12.8211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.353166
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.643137 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31394",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_31394",
    x: 13.6941,
    y: 4.69357,
    width: 13.4042,
    height: 6.81266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.353166
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.643137 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31394",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_14652_31394",
    x: -0.0676405,
    y: 16.5907,
    width: 27.8559,
    height: 25.4275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.431647
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.643137 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31394",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeAtendimentoDomiciliar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-atendimento-domiciliar.751ae7c9.svg";
export { ForwardRef as ReactComponent };